var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 498 496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#687389;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48,448h96V368H48Zm16-64h64v48H64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176,368v80h96V368Zm80,64H192V384h64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112,168V88A24,24,0,0,0,88,64H72A24,24,0,0,0,48,88v80a24,24,0,0,0,24,24H88A24,24,0,0,0,112,168Zm-48,0V88a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H72A8,8,0,0,1,64,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.21,197.44a24.64,24.64,0,0,0-30.4,0L355.87,208H223.32a56.07,56.07,0,0,0,.68-8V168H324.28L340,144.42,355.72,168h16.56L388,144.42,403.72,168h16.56L436,144.42,451.72,168H468l30-40L468,88H224V56A56.07,56.07,0,0,0,168,0H56A56.07,56.07,0,0,0,0,56V200a55.87,55.87,0,0,0,32.13,50.45L0,276.16V336H16V496H480V310.48a23.8,23.8,0,0,0,7.18-41.07ZM379,209.79a8.2,8.2,0,0,1,10.12,0l88,72a8,8,0,0,1,1.13,11.27A8.21,8.21,0,0,1,467,294.2L384,226.34l-82.91,67.84a8.24,8.24,0,0,1-11.29-1.13,8,8,0,0,1,1.14-11.24ZM280.8,269.43a24,24,0,0,0-3.38,33.75A22.93,22.93,0,0,0,288,310.33V320H16V288H256V272H30.81l60-48H336.32ZM304,152H224V136h72a8,8,0,0,1,8,8Zm156-48,18,24-17.85,23.81L444.28,128H427.72L412,151.58,396.28,128H379.72L364,151.58,348.28,128H331.72L320,145.58V144a24,24,0,0,0-24-24H224V104ZM16,200V56A40,40,0,0,1,56,16H168a40,40,0,0,1,40,40V200a39.53,39.53,0,0,1-.89,8H85.19L46.71,238.78A39.88,39.88,0,0,1,16,200ZM32,336H288V480H32ZM432,480H416V384H352v96H336V400a48,48,0,0,1,96,0Zm-32,0H368V400h32Zm48,0V400a64,64,0,0,0-128,0v80H304V310.4a22.52,22.52,0,0,0,7.18-3.82L384,247l72.82,59.57a24.29,24.29,0,0,0,7.18,4V480Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.586e070aab56a387816b422021b27534.svg";
export { ForwardRef as ReactComponent };